import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeetingService } from 'src/app/service/meeting.service';
// import { form_dataSources} from 'src/app/mock';
import { FormControl, Validators } from '@angular/forms';
import { form_dataSources } from 'src/app/mock';
// import { form_dataSources } from 'src/app/models/basicMeetingModel';

@Component({
  selector: 'app-protean-forms',
  templateUrl: './protean-forms.component.html',
  styleUrl: './protean-forms.component.css'
})
export class ProteanFormsComponent {
  dataSource = form_dataSources;
  form_response: any;
  noData = false;
  totalItems = 25;
  itemsPerPageArr = [5, 10, 20, 30];
  size = 10;
  noteId: any;
  particToggler = true;
  responseType = 'single';
  toppingsControl: any = new FormControl([Validators.required]);
  meetingResponse: any;
  newPresenterList: any = [];
  constructor(public meetingService: MeetingService, @Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<ProteanFormsComponent>) {
    this.toppingsControl.setValue(null);
    this.meetingResponse = data['meetingRes'];
    this.form_response = data['form_response'];
    this.noteId = data['noteId']
    this.dataSource =
    {
      ...this.dataSource,
      data: this.form_response.data.results
    }
    this.totalItems = this.form_response.data.pagination.totalItems
  }

  openForm(event: any) {
    var formId = {
      formId: event.row.formId
    }
    this.meetingService.getFormDetails(formId).subscribe((res: any) => {
      let div = document.getElementById('agMinIdWidget' + this.noteId) as HTMLDivElement
      const userList = this.toppingsControl.value.map((user: any) => user.fkSecUserAttendee);
      this.dialogRef.close({ data: res.body.data.results, editRights: userList, resType: this.responseType });
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }


  columnSearch(event: any) {
    console.log("hello : ", event)
  }

  itemsPerPageChange(event: any) {
    console.log("items per page : ", event)
  }

  pageChange(event: any) {
    this.dataSource =
    {
      ...this.dataSource,
      data: []
    }

    var req = {
      page: event,
      size: this.size
    }
    this.meetingService.getAllProteanForm(req).subscribe((res: any) => {
      if (res.body.data.results.length != 0) {
        this.noData = false;
        this.dataSource =
        {
          ...this.dataSource,
          data: res.body.data.results
        }
        this.totalItems = res.body.data.pagination.totalItems;
      }
      else {
        this.noData = true;
      }
    })


    // this.reportService.getDrilldownMeetingData(this.req).subscribe((data: any) => {
    //      if(data.body.response.RESULT.ROWSET.ROW.length!=0){
    //       this.noData = false;
    //       this.dataSource = 
    //       { ...this.dataSource,
    //         data : data.body.response.RESULT.ROWSET.ROW }
    //       this.totalItems = data.body.response.RESULT.METADATA.TOTAL_RECORD_COUNT;
    //      }
    //      else{
    //       this.noData = true;

    //      }
    // })

  }



  showAddParticipants() {
    this.particToggler = true
    this.toppingsControl.setValue([]);
  }

  hideAddParticipants() {
    this.particToggler = false
    this.toppingsControl.setValue(this.meetingResponse.attendeeList)
  }

  callTrigger() {
    this.toppingsControl.setValue(this.toppingsControl.value);
  }

  onToppingRemoved(topping: any, type: any) {
    if (type == 0) {
      const toppings = this.toppingsControl.value as any[];
      this.removeFirst(toppings, topping);
      this.callTrigger();
    }
    else {
      const additionalpart = this.newPresenterList;
      this.removeFirst(additionalpart, topping)
    }
  }
  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
}
